import { NotificationInfoOutlineIcon } from '@tableau/icons/NotificationInfoOutlineIcon';
import { TabStyles, TextFieldWidget, Tooltip } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';


export type AddFileServerUsernameFieldProps = Readonly<{
  onUserNameChange: (domainName: string) => void;
  username: string;
}>;

export function AddFileServerUsernameField(props: AddFileServerUsernameFieldProps) {
  return (
    <TextFieldWidget
      label={renderLabelWithTooltip(Messages.dataConnectSiteSettingsDomainFileServerUsername())}
      onChange={e => props.onUserNameChange(e.target.value)}
      onClear={() => props.onUserNameChange('')}
      placeholder={Messages.dataConnectSiteSettingsDomainFileServerUsernamePlaceholder()}
      testId={'fileserver-username-widget'}
      value={props.username}
      kind={'outline'}
      className={textFieldClass}
      style={{ width: '100%' }} />
  );
}

function renderLabelWithTooltip(label: string) {
  return <>
    <span>{label}</span>
    <span style={{paddingLeft: 4, verticalAlign: 'text-top'}}>
      <Tooltip children={<NotificationInfoOutlineIcon size={14} alt={''} />}
        tooltipContent={
        renderTooltip(Messages.dataConnectSiteSettingsDomainFileServerUsernameToolTip())}
        position={Tooltip.defaultProps.position!}
        afterDelay={false}
        followCursor={false} />
    </span>
  </>;
}


function renderTooltip(text: string) {
  return <div >
    <span style={{display:'block'}}>{text}</span>
  </div>;
}

const textFieldClass = cssClass('fileserver-username-field', 'root', {
  width: '100%',
  marginTop: TabStyles.Spacing.LargeSpace
});
